import axios from 'axios'
import { getAPIService } from '../../getServerHost'
import { roomId } from '../types'

export const roomDelete = async (payload: roomId) => {
  const response = await axios.delete(`${getAPIService}/v2/api/rooms/${payload}`)
  return response.data
}
